import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kve-home-input-slideshow',
  templateUrl: './home-input-slideshow.component.html',
  styleUrls: ['./home-input-slideshow.component.scss']
})
export class HomeInputSlideshowComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
